<template>
    <div class="dynamics main_width main_color m_0">
        <div class="title">了解汽修宝最新动态</div>
        <div class="more" @click="toMore">查看更多<img src="../../../static/images2/go.png" alt=""></div>
        <div class="centent">
            <div v-for="(item, index) in list" :key="index" class="item" @click="clickItem(item)">
                <img :src="item.cover_image" alt="">
                <p class="text-over-2-line">{{ item.title }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import { _trackCustomEvent, onEventGsIdo } from '../../utils/index.js'
export default {
  name: "dynamics",
  data() {
    return {
        list: []
    };
  },
  created() {
    this.getList();
  },

  methods: {
    async getList() {
        const formData = new FormData();
        formData.append('column_id', 47);
        try {
            const response = await fetch(`https://api.qixiubao.cn/api/?version=5.20.0.3&action=API.Article.getArticleList`, {
                method: 'POST',
                body: formData
            })
            if (!response.ok) {
                throw new Error('网络响应失败');
            }

            const data = await response.json();
            if(data.code == 200) {
                this.list = data.data.list.slice(0, 3)
            } else {
                alert(data.msg)
            }
            console.log('请求成功:', data);
        } catch (error) {
            console.error('请求失败:', error);
        }
    },
    clickItem(item) {
        _trackCustomEvent('homeArticle', item)
        onEventGsIdo('qxb_$article', '查看文章')
        if(!item.jump_url) return
        window.open(item.jump_url)
    },
    toMore() {
        this.$router.push('/articleList')
        onEventGsIdo('qxb_$more', '查看更多')
    }
  },
  mounted() {
    this.getList()
  }
}
</script>
<style scoped lang="less">
@import "../../assets/style/utils.less";
.dynamics {
    box-sizing: border-box;
    padding: .px2vw(48)[@result] 0 .px2vw(80)[@result];
    text-align: center;
    font-size: 0;
    .title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(16)[@result];
    }
    .more {
        font-size: .px2vw(16)[@result];
        color: #165DFF;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-bottom: .px2vw(32)[@result];
        img {
            width: .px2vw(16)[@result];
            height: .px2vw(16)[@result];
        }
    }
    .centent {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: .px2vw(1280)[@result];
        margin: 0 auto;
        .item {
            cursor: pointer;
            img {
                width: .px2vw(398)[@result];
                height: .px2vw(254)[@result];
                border-radius: .px2vw(10)[@result];
                object-fit: cover;
            }
            p {
                font-weight: 700;
                font-size: .px2vw(16)[@result];
                margin-top: .px2vw(24)[@result];
                text-align: left;
            }
        }
    }
}
.text-over-2-line {
    display: -webkit-box; /*重点，不能用block等其他，将对象作为弹性伸缩盒子模型显示*/
    /*! autoprefixer: off */
    -webkit-box-orient: vertical; /*从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）*/
    -webkit-line-clamp: 2; /*行数，超出三行隐藏且多余的用省略号表示...*/
    line-clamp: 2;
    text-overflow: ellipsis;
    word-break: break-all;
    overflow: hidden;
    max-width: 100%;
    white-space: break-spaces;
}
@media screen and (max-width: 900px) {
    .dynamics {
        padding: .h5px2vw(32)[@result] .h5px2vw(24)[@result] 0;
        .title {
           font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(16)[@result]; 
        }
        .more {
            font-size: .h5px2vw(24)[@result];
            margin-bottom: 0;
            img {
                width: .h5px2vw(24)[@result];
                height: .h5px2vw(24)[@result];
            }
        }
        .centent {
            display: block;
            width: 100%;
            margin-bottom: .h5px2vw(16)[@result];
            .item {
                display: flex;
                flex-direction: row-reverse;
                padding: .h5px2vw(24)[@result] 0;
                img {
                    width: .h5px2vw(264)[@result];
                    height: .h5px2vw(166)[@result];
                    border-radius: .h5px2vw(7)[@result];
                }
                p {
                    font-size: .h5px2vw(28)[@result];
                    line-height: .h5px2vw(36)[@result];
                    flex: 1;
                }
            }
            .item:not(:last-child) {
                border-bottom: .h5px2vw(1)[@result] solid #D8D8D8;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/dynamics.vue